var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTf({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.941 44.5v36.836L46.324 62.918V26.082zm0 0",
    fill: "#5c4ee5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.41 81.336l31.633-18.418V26.082L81.41 44.5zm0 0",
    fill: "#4040b2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.242 42.36L42.86 60.776V23.941L11.242 5.523zm0 0M77.941 85.375L46.324 66.957v36.82l31.617 18.418zm0 0",
    fill: "#5c4ee5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTf);
export default __webpack_public_path__ + "static/media/tf.21d15a7b8a945908ecb74df1851012ea.svg";
export { ForwardRef as ReactComponent };